import React from 'react';
import { Box, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import LandingButtons from '../components/Drawer/toolbar/LandingButtons';
import Footer from '../components/Footer';

const PublicLayout: React.FC = () => (
  <div
    style={{
      background: '#f6f9fb',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}
  >
    <Box
      sx={{
        p: 1,
        maxWidth: 1200,
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        flex: 1,
      }}
    >
      <LandingButtons />
      <Grid container>
        <Grid item xs={12} pt={2}>
          <Outlet />
        </Grid>
      </Grid>
    </Box>
    <Footer />
  </div>
);

export default PublicLayout;
